import React, { useState } from "react";
import { ChevronLeft, Bicycle, CarFrontFill, Coin } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion12.module.scss";
import { Badge } from "antd";
const Accardion12 = ({dataCount}) => {
  const [openAll , setOpenAll]=useState(false)

  const ItemList = [
    {
      id: "1",
      title: "درخواست پرداخت جدید",
      link: "/newpayreq",
      active: window.location.pathname === "/newpayreq",
      count:dataCount&&parseInt(dataCount)
    },
    {
      id: "2",
      title: "بایگانی پرداختی ها",
      link: "/payedreq",
      active: window.location.pathname === "/payedreq",
    },

  ];

  let value = false;
  ItemList.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });

  const openHandlerAll=()=>{
    if(openAll){
      setOpenAll(false)
    }
    else{
      setOpenAll(true)
    }
  }
  return (
    <div className={Style.componentHolder}>
      <div
        className={value || openAll ? Style.background : Style.accardionTitle}
        onClick={openHandlerAll}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}> درخواست پرداخت   {dataCount&&<Badge count={dataCount}/>}</p>
          <Coin />
        </div>
      </div>
      <div className={value ||openAll ? Style.inneraccardionContent : Style.hidden}>
        <AccardionItem accardonItem={ItemList && ItemList} />
      </div>
    </div>
  );
};

export default Accardion12;
